import React from 'react';
import ReactDOM from 'react-dom';
import 'react-app-polyfill/ie9';
import 'formdata-polyfill';
import 'core-js';
import { Provider } from 'react-redux';
import {
    HashRouter as Router,
} from "react-router-dom";
import App from './App';
import store from './store/store';
import { getQueryString, currentPageRedirect, isMobileDev } from './utils/common';

import './assets/index.scss';
import './assets/reset.scss';
import './utils/mailStats';
import './utils/performanceCollector';


function main() {
    try {
        if (!isMobileDev()) {
            ReactDOM.render(
                <Provider store={store}>
                    <Router>
                        <App />
                    </Router>
                </Provider>,
                document.getElementById('root'));

            var token = getQueryString('token') || '';
            if (token) {
                document.cookie = `acrepair_token=${token}; path=/`;
            }
            //@ts-ignore
            (window as any).repair_add_time = 0;

            window.onbeforeunload = function (e: Event) {
                e = e || window.event;
                // 首页跳转不做拦截
                if (window.location.hash === '#/' || window.location.hash.indexOf('#/?') > -1) {
                    return;
                }
                // 安全手机绑定页不做拦截
                if (window.location.hash.indexOf('safePhoneBind') > -1) {
                    return;
                }
                // 风控错误结果页回到首页不做拦截
                if (window.location.hash.indexOf('status=-1') > -1) {
                    return;
                }
                // 公示列表页不做拦截
                if (window.location.hash.indexOf('taskPublicity') > -1) {
                    return;
                }
                if (e) {
                    //@ts-ignore
                    e.returnValue = '关闭页面可能会造成页面信息的丢失，确定继续关闭？';
                }
                return '关闭页面可能会造成页面信息的丢失，确定继续关闭？';
            };
            return;
        }
        currentPageRedirect();
    } catch (e) {
        console.log("页面渲染异常", e);
    }
}
main();